module.exports = __webpack_public_path__ + "static/media/money-stress-bro-people.6f4f6f35.svg";